import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TemplatesSection from './components/TemplatesSection';
import HostingSection from './components/HostingSection';
import LaunchSection from './components/LaunchSection';
import PortfolioSEO from '../../components/seo/PortfolioSEO';

const PortfolioPage = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return (
    <>
      <PortfolioSEO />
      <Navbar scrolled={false} />
      <TemplatesSection />
      <HostingSection />
      <LaunchSection />
      <Footer />
    </>
  );
};

export default PortfolioPage;
